// Atribución de marketing en el alta: UTMs + cookies de Meta (_fbc/_fbp) +
// código de referido → profiles. Extraído del patrón de Auth/AuthCompat para
// reutilizarlo en altas que NO pasan por /auth (EnterpriseCheckout, el alta
// directa con pago — ADR-613; esa pantalla perdía la atribución).
//
// Dos mitades:
//   1. captureAttributionParams() — al MONTAR la pantalla de alta: baja los
//      UTMs/ref de la URL y las cookies de Meta a localStorage (así
//      sobreviven la navegación y el submit).
//   2. saveSignupAttribution(userId) — tras el signUp exitoso: persiste todo
//      en la fila de profiles (la crea el trigger de la DB al registrarse).
//      Best-effort TOTAL: nunca lanza — jamás debe romper un alta o un pago.

import { supabase } from './supabase';
import { ensureMetaParams } from './metaParams';

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const;

export function captureAttributionParams(): void {
  try {
    // Primero el fallback de Meta: si el píxel no corrió, esto materializa
    // _fbc desde el fbclid de la URL y genera _fbp — así las lecturas de
    // cookies de abajo siempre encuentran algo que guardar.
    ensureMetaParams();
    const params = new URLSearchParams(window.location.search);
    for (const key of UTM_KEYS) {
      const val = params.get(key);
      if (val) {
        try {
          localStorage.setItem(`atlas:${key}`, val);
        } catch {}
      }
    }
    const ref = params.get('ref');
    if (ref) {
      try {
        localStorage.setItem('atlas:ref', ref);
      } catch {}
    }
    const getCookie = (name: string): string | null => {
      const match = document.cookie.match(
        new RegExp('(?:^|; )' + name + '=([^;]*)'),
      );
      return match ? decodeURIComponent(match[1]) : null;
    };
    const fbc = getCookie('_fbc');
    const fbp = getCookie('_fbp');
    if (fbc) {
      try {
        localStorage.setItem('atlas:fbc', fbc);
      } catch {}
    }
    if (fbp) {
      try {
        localStorage.setItem('atlas:fbp', fbp);
      } catch {}
    }
  } catch {}
}

/**
 * Código de referido vigente: el de la URL si está, y si no el que quedó guardado
 * (y de paso lo persiste). Se necesita ANTES de crear el usuario —viaja en la
 * metadata del `signUp` y el trigger `handle_new_user` lo baja a
 * `profiles.ref_code`— y otra vez después, en `saveSignupAttribution`. Por eso es
 * su propia función exportada y no queda inline.
 */
export function refCodeActual(): string | null {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) {
      try {
        localStorage.setItem('atlas:ref', ref);
      } catch {}
      return ref;
    }
    return localStorage.getItem('atlas:ref');
  } catch {
    return null;
  }
}

export async function saveSignupAttribution(userId: string): Promise<void> {
  try {
    const utmData: Record<string, string | null> = {};
    for (const key of UTM_KEYS) {
      utmData[key] = localStorage.getItem(`atlas:${key}`) || null;
    }
    utmData.fbc = localStorage.getItem('atlas:fbc') || null;
    utmData.fbp = localStorage.getItem('atlas:fbp') || null;
    const refCode = refCodeActual();
    if (refCode) utmData.ref_code = refCode;
    const hasAny = Object.values(utmData).some((v) => v !== null);
    if (hasAny) {
      await supabase.from('profiles').update(utmData).eq('id', userId);
    }
  } catch {}
}
